import { render, staticRenderFns } from "./Asignacion_sede_v4.vue?vue&type=template&id=bb7aaa6c&scoped=true"
import script from "./Asignacion_sede_v4.vue?vue&type=script&lang=js"
export * from "./Asignacion_sede_v4.vue?vue&type=script&lang=js"
import style0 from "./Asignacion_sede_v4.vue?vue&type=style&index=0&id=bb7aaa6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb7aaa6c",
  null
  
)

export default component.exports